import React from "react";
import { Radar, RadarChart, PolarGrid } from "recharts";
import { useTranslation } from "react-i18next";


function sortByStartingLetter(a = '', b = '', startingLetters) {
  const aStart = startingLetters.indexOf(a.charAt(0).toLowerCase());
  const bStart = startingLetters.indexOf(b.charAt(0).toLowerCase());
  return aStart - bStart;
}

const startingLetters = ['i', 'r', 'a', 'c', 'e', 's'];

const ResultChart = ({ item }) => {
  const { t } = useTranslation("result");

  let newArray = [];
  Object.keys(item?.prediction?.holland?.values)
    .sort((a, b) => sortByStartingLetter(a, b, startingLetters))
    .map((key) => {
      newArray.push({
        type: key,
        value: parseFloat(item?.prediction?.holland?.values[key].replace("%", "")),
        total: 100,
      });
    });
  return (
    <div className="relative">
      <RadarChart
        cx={300}
        cy={250}
        outerRadius={150}
        width={560}
        height={440}
        data={newArray}
        className="sm-max:!w-[100%] sm-max:!h-[50%]"
      >
        <PolarGrid />
        {t("polarAngleAxisData", { returnObjects: true }).map((item) => (
          <g class="recharts-layer recharts-polar-angle-axis-tick">
            <line
              class="angleAxis"
              cx="300"
              cy="250"
              orientation="outer"
              radius="150"
              fill="#3976F9"
              x1={item.line_x1}
              y1={item.line_y1}
              x2={item.line_x2}
              y2={item.line_y2}
            ></line>
            <text
              cx="300"
              cy="250"
              orientation="outer"
              radius="150"
              stroke="black"
              x={item.text_x}
              y={item.text_y}
              class="recharts-text recharts-polar-angle-axis-tick-value"
              text-anchor={item.text_anchor}
              fill="black"
              fontWeight={"200"}
            >
              <tspan className="text-primary-blue" x={item.tspan_x} dy="0em">
                {item.axis_name}
              </tspan>
            </text>
          </g>
        ))}
        <Radar
          dataKey="value"
          stroke="#3976F9"
          fill="#3976F9"
          fillOpacity={0.6}
        />
        {newArray.map((entry, index) => {
          const labelWidth = entry.type.length * 0;
          const x =
            Math.cos(-Math.PI / 2 - (index * 2 * Math.PI) / newArray.length) *
            -200 +
            300 -
            labelWidth / 3;
          const labelHeight = 20;
          const y =
            Math.sin(-Math.PI / 2 - (index * 2 * Math.PI) / newArray.length) *
            175 +
            260 -
            labelHeight;
          return (
            <text
              key={`text-${index}`}
              x={x}
              y={y}
              textAnchor="middle"
              dominantBaseline="bottom"
              fill="#3976F9"
              fontWeight="bold"
            >
              {`${entry.value}%`}
            </text>
          );
        })}
      </RadarChart>
    </div>
  );
};

export default ResultChart;
